export default __webpack_public_path__ + "static/media/tree-austin-crop.11483422.jpg";